import React from 'react';
import { Icon } from '@fasstech/middle-design-system';

const CompanyCard = ({
  keyCompany,
  getMiddleText,
  siret,
  onClick,
  disabled = false,
  name,
  addresses,
  legalForm,
  className = '',
  iconName,
  dataTestId
}) => {
  return (
    <div key={keyCompany}>
      <div className={`border border-[#E7E7E7] rounded-lg p-2 my-4 ${className}`}>
        <table className="w-full table-fixed border-collapse h-full">
          <tbody>
            <tr>
              <th className="text-left font-bold p-2">{getMiddleText('ENTREPRISE_SIRET_LABEL')}</th>
              <td className="p-2">{siret || '-'}</td>
              <td rowSpan={6} className="p-2 align-top w-[80px] h-full">
                <div className="flex flex-col justify-between items-end h-full">
                  <Icon
                    name={iconName}
                    size={30}
                    onClick={onClick}
                    className={disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
                    data-testid={dataTestId}
                  />
                  <Icon name="circlePen" size={30} className={'cursor-pointer'} />
                </div>
              </td>
            </tr>
            <tr>
              <th className="text-left font-bold p-2">{getMiddleText('ENTREPRISE_NOM_LABEL')}</th>
              <td className="p-2">{name || '-'}</td>
            </tr>
            <tr>
              <th className="text-left font-bold p-2">
                {getMiddleText('ENTREPRISE_ADRESSE_LABEL')}
              </th>
              <td className="p-2">{addresses[0].fields[0] || '-'}</td>
            </tr>
            <tr>
              <th className="text-left font-bold p-2">
                {getMiddleText('ENTREPRISE_CODE_POSTAL_LABEL')}
              </th>
              <td className="p-2">{addresses[0].zipCode || '-'}</td>
            </tr>
            <tr>
              <th className="text-left font-bold p-2">{getMiddleText('ENTREPRISE_VILLE_LABEL')}</th>
              <td className="p-2">{addresses[0].city || '-'}</td>
            </tr>
            <tr>
              <th className="text-left font-bold p-2">
                {getMiddleText('ENTREPRISE_FORME_JURIDIQUE_LABEL')}
              </th>
              <td className="p-2">{legalForm || '-'}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CompanyCard;
